import React from 'react'

const PremiumFeatures = () => {
  return (
    <div>
      
    </div>
  )
}

export default PremiumFeatures
